<template>
  <div class="app-div">
     <router-view/>
    <loading v-if="isLoading"/>
  </div>
</template>
<style scoped>
  .app-div {
    height: 100vh;
  }
</style>

<script>
  import Loading from '@/components/Loading'
  import ApiClient from '@/utils/api-client'

  export default {
    name: 'app',
    components: { Loading },
    computed: {
      isLoading() {
        return this.$store.state.isLoading
      }
    },
    beforeCreate() {

      // window.document.title= 'Dashboard IOUU';

      const reloadPage = () => {
        const oldPath = this.$route.fullPath
        this.$router.push('/')
        this.$router.push(oldPath)
      }
      ApiClient.validateToken()
        .then(result => {
          if(result) {
            this.$store.dispatch('updateUser')
          } else {
            this.$store.dispatch('logout')
            reloadPage()
          }
        })
        .catch(() => {
          this.$store.dispatch('logout')
          reloadPage()
        })
    },

    metaInfo: {
      title: 'Dashboard',
      titleTemplate: '%s | IOUU'
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue